import NotificationMixin from './NotificationMixin';
import { formatDateTimeSecond, formatDateTime, formatDate } from '../utils/dates';

export default {
  mixins: [NotificationMixin],
  data() {
    return {
      item: {}
    };
  },
  created() {
    this.retrieve(decodeURIComponent(this.$route.params.id));
  },
  beforeDestroy() {
    this.reset();
  },
  computed: {
    retrieved() {
      return this.find(decodeURIComponent(this.$route.params.id));
    }
  },
  methods: {
    del() {
      if(this.$options.routeAfterDel) {
        this.deleteItem(this.retrieved).then(() => {
          if (this.item['name']) {
            this.showMessage(`${this.item['name']} ${this.$t('global.deleted')}`);
          } else {
            this.showMessage(`${this.item['@id']} ${this.$t('global.deleted')}`);
          }
          if(this.$options.routeAfterDelIdObject) {
            this.$router
              .push(
                { name: `${this.$options.routeAfterDel}` ,
                params: { id: this.item[this.$options.routeAfterDelId]['@id'] }}

              )
              .catch(() => {});
          }else {
            this.$router
              .push(
                { name: `${this.$options.routeAfterDel}` ,
                params: { id: this.item[this.$options.routeAfterDelId] }}

              )
              .catch(() => {});
          }



        });
      } else {
        this.deleteItem(this.retrieved).then(() => {
          if (this.item['name']) {
            this.showMessage(`${this.item['name']} ${this.$t('global.deleted')}`);
          } else {
            this.showMessage(`${this.item['@id']} ${this.$t('global.deleted')}`);
          }
          this.$router
            .push({ name: `${this.$options.servicePrefix}List` })
            .catch(() => {});

        });
      }

    },
    formatDateTime,
    formatDate,
    formatDateTimeSecond,
    reset() {
      this.$refs.updateForm.$v.$reset();
  //    this.createReset();
    },
    navback() {
      this.$router.go(-1);
    },
    onSendForm() {
      const updateForm = this.$refs.updateForm;
      updateForm.$v.$touch();

      if (!updateForm.$v.$invalid) {
        let object = updateForm.$v.item.$model;

        // Correction bug : data combobox null -> ne met pas à 0 l'object
        Object.keys(object).forEach(function(key){
          if (object[key] == undefined) {
            object[key] = null;
          }
        });

        this.update(object);
      }
    },

    resetForm() {
      this.$refs.updateForm.$v.$reset();
      this.item = { ...this.retrieved };
    },
    onUploaded(item) {
      this.item.fileUploaded = true;
      this.item.file = item;
      if (item['name']) {
        this.showMessage(`${item['original_name']} ${this.$t('global.uploaded')}`);
      } else {
        this.showMessage(`${item['@id']} ${this.$t('global.uploaded')}`);
      }
    },
  },
  watch: {
    deleted(deleted) {
      if (!deleted) {
        return;
      }
      this.$router
        .push({ name: `${this.$options.servicePrefix}List` })
        .catch(() => {});
    },

    error(message) {
      if (message == 'NotConnected') {
        console.log(403);
        this.$root.isConnected = false;
        this.$root.passwordTurnover = false;
        if (! this.$root.originalUrlConnected) this.$root.originalUrlConnected = this.$route;
        if(this.$route.name != 'RegenPassword') this.$router.push({ name: `Login` });
      }else {
        message && this.showError(message);
      }
    },

    deleteError(message) {
      message && this.showError(message);
    },

    updated(val) {
      if (this.inputfile) {
        this.uploadFileCreateItem(val['id'],val['@entity'],this.inputfile,'file');
      }
      if (val['name']) {
        this.showMessage(`${val['name']} ${this.$t('global.updated')}`);
      } else {
        this.showMessage(`${val['@id']} ${this.$t('global.updated')}`);
      }
    },
    uploaded(uploaded) {
      if (!uploaded) {
        return;
      }

      this.onUploaded(uploaded);
    },
    retrieved(val) {
      this.item = { ...val };
    }
  }
};
